/* Copyright 2016 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* globals module, __non_webpack_require__ */

'use strict';

var pdfjsLib;
if (typeof window !== 'undefined' && window['embed-pdfjs-dist/build/pdf']) {
	pdfjsLib = window['embed-pdfjs-dist/build/pdf'];
} else {
	pdfjsLib = __non_webpack_require__('../build/pdf.js');
}
module.exports = pdfjsLib;



// WEBPACK FOOTER //
// web/pdfjs.js